import { Routes } from '@angular/router';
import { authGuard, guestGuard } from '@core/auth/auth.guards';

export const routes: Routes = [
  {
    path: 'login',
    canMatch: [guestGuard],
    loadChildren: () => import('@features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'widget-book',
    loadChildren: () =>
      import('@features/widget-book/widget-book.routes').then((m) => m.WIDGET_BOOK_ROUTES),
  },
  {
    path: '',
    canMatch: [authGuard],
    loadComponent: () => import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: 'members',
        loadChildren: () =>
          import('@features/members/members.routes').then((m) => m.MEMBERS_ROUTES),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('@features/earning-configuration/earning-configuration.routes').then(
            (m) => m.EARNING_CONFIGURATION_ROUTES,
          ),
      },
      {
        path: 'receipt-queue',
        loadChildren: () =>
          import('@features/receipt-queue/receipt-queue.routes').then(
            (m) => m.RECEIPT_QUEUE_ROUTES,
          ),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('@features/products/products.routes').then((m) => m.PRODUCTS_ROUTES),
      },
      {
        path: 'receipt-submissions',
        loadChildren: () =>
          import('@features/receipt-submissions/receipt-submissions.routes').then(
            (m) => m.RECEIPT_SUBMISSIONS_ROUTES,
          ),
      },
    ],
  },
  {
    path: '**',
    title: 'Not found',
    loadComponent: () => import('./layout/not-found/not-found.page').then((m) => m.NotFoundPage),
  },
];
